import React from 'react'
import {TEMPLATE_PAGE_IN_CONSTRUCTION} from "../index";

const Forum = () => {
    return (
        <>
            <div className="inner-head bg-animate">
                <div className="container">
                    <div className="row text-center">
                        <div className="col-md-8 col-md-offset-2">
                            <h3>Forum</h3>
                        </div>
                    </div>
                </div>
            </div>

            <div className="clearfix"></div>
            <div className="inner-page">
                <div className="container">
                    <div className="row">{TEMPLATE_PAGE_IN_CONSTRUCTION}</div>
                </div>
            </div>
        </>
    );
}

export default Forum;